module.exports = __webpack_public_path__ + "static/media/90900.f6d35046.png";